import { DirectiveOptions } from 'vue';
import App from '../app';

export interface Slide {
    src?: string;
    title?: string;
    w?: number;
    h?: number;
    html?: string;
}

const filterAnchors = (anchors: NodeListOf<HTMLAnchorElement>): HTMLAnchorElement[] => {
    return Array.from(anchors).filter((anchor: HTMLAnchorElement) => {
            return anchor.classList.contains('u-swiped') ||
                   anchor.classList.contains('c-playlink') ||
                   /\.(jpg|gif|png|jpeg)$/im.test((anchor.getAttribute('href') || '').trim());
    });
};

const processVideoAnchor = (anchor: HTMLAnchorElement): Slide => {
    const href = anchor.getAttribute('href') || '';
    return {
        src: '',
        html: '<div class="u-video-center"><div class="pswp__video-container"><div is="youtube-video" class="pswp__video" src="' + href + '"></div></div></div>',
    };
};

const processImageAnchor = (anchor: HTMLAnchorElement): Slide => {
    const src = anchor.getAttribute('href') || '';
    const title = anchor.getAttribute('title') || '';
    const item: Slide = { src, title };
    const img = new Image();

    img.addEventListener('load', function() {
        item.w = this.naturalWidth;
        item.h = this.naturalHeight;
    });

    img.src = src;

    return item;
};

const swipedContent: DirectiveOptions = {
    bind(el, { value }: { value: string }): void {
        const items: Slide[] = [];
        const anchors = filterAnchors(el.getElementsByTagName('a'));
        const imageAnchors = anchors.filter((anchor) => anchor.classList.contains('u-swiped'));
        const eventName = 'slideClick' + (value ? ':' + value : '');
        imageAnchors.forEach((slide: HTMLAnchorElement, index: number) => {
            items.push(processImageAnchor(slide));
            slide.addEventListener('click', (event) => {
                App.$emit(eventName, items, index, slide);
                event.preventDefault();
            });
        });
        anchors.forEach((slide: HTMLAnchorElement, index: number) => {
            if (!slide.classList.contains('u-swiped') && /\.(jpg|gif|png|jpeg)$/im.test((slide.getAttribute('href') || '').trim())) {
                const item = processImageAnchor(slide);
                slide.addEventListener('click', (event) => {
                    App.$emit(eventName, [item], 0, slide);
                    event.preventDefault();
                });
            } else if (slide.classList.contains('c-playlink')) {
                const item = processVideoAnchor(slide);
                slide.addEventListener('click', (event) => {
                    App.$emit(eventName, [item], 0, slide);
                    event.preventDefault();
                });
            }
        });
    },
};

const swipedVideos: DirectiveOptions = {
    bind(el, { value }: { value: string }): void {
        const eventName = 'slideClick' + (value ? ':' + value : '');
        const anchors = filterAnchors(el.getElementsByTagName('a'));
        anchors.forEach((slide: HTMLAnchorElement, index: number) => {
            if (slide.classList.contains('c-playlink')) {
                const item = processVideoAnchor(slide);
                slide.addEventListener('click', (event) => {
                    App.$emit(eventName, [item], 0, slide);
                    event.preventDefault();
                });
            }
        });
    },
};

export {swipedContent, swipedVideos};



// WEBPACK FOOTER //
// ./src/directives/swipedContent.ts